module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "u-relative u-fit"
  }, [_c('div', {
    staticClass: "c-home-slide--0__main-container u-relative u-fit"
  }, [_c('div', {
    staticClass: "c-home-slide--0__container u-absolute u-fit"
  }, [_c('div', {
    staticClass: "c-home-slide--0__left u-absolute"
  }, [_c('div', {
    staticClass: "c-home-slide--0__left-background c-home-slide__element has-delay-0 u-absolute u-fit u-bg--brand-primary"
  }), _vm._v(" "), _c('div', {
    staticClass: "c-home-slide--0__container__top-left-content c-home-slide__element has-delay-1 u-relative"
  }, [_c('app-icon', {
    staticClass: "c-home-slide--0__container__top-left-logo u-absolute u-post-tl u-fit u-fill--white u-stroke--white",
    attrs: {
      "name": "logotype"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "c-home-slide--0__container__bottom-left-content c-home-slide__element has-delay-2"
  }, [_c('app-socials-links', {
    staticClass: "c-socials-links u-uppercase t-fweight--semi-bold t-fsize--xs"
  })], 1)]), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "c-home-slide--0__footer c-home-slide__element has-delay-6 u-relative u-fit-w u-height--footer u-bg--black"
  }, [_c('div', {
    staticClass: "c-home-slide--0__footer__wrapper u-relative u-fit"
  }, [_c('div', {
    staticClass: "c-home-slide--0__footer__be-notified u-relative u-flex u-flex-ai--center u-fit-h u-cursor-pointer",
    on: {
      "click": function($event) {
        _vm._clickOnBeNotified()
      }
    }
  }, [_c('div', {
    staticClass: "c-home-slide--0__footer__be-notified__text u-marg-l-w4of12 u-uppercase t-ffamily--simplon t-fweight--bold u-color--white u-align-center"
  }, [_vm._v("\n                    Be notified\n                ")])]), _vm._v(" "), _c('a', {
    staticClass: "c-home-slide--0__footer__download u-relative u-flex u-flex-ai--center u-fit-h u-cursor-pointer",
    attrs: {
      "href": _vm.$root.content.global.whitepaper.url,
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_c('div', {
    staticClass: "c-home-slide--0__footer__download__text u-relative u-uppercase t-ffamily--simplon t-fsize--xs t-fweight--bold u-color--white"
  }, [_c('div', {
    staticClass: "c-home-slide--0__footer__download__text__icon-container u-absolute u-overflow-h"
  }, [_c('app-icon', {
    staticClass: "c-home-slide--0__footer__download__text__icon--1 u-absolute u-fill--white u-stroke--white",
    attrs: {
      "name": "icon-arrow--down",
      "width": "100%",
      "height": "100%"
    }
  }), _vm._v(" "), _c('app-icon', {
    staticClass: "c-home-slide--0__footer__download__text__icon--2 u-absolute u-fill--white u-stroke--white",
    attrs: {
      "name": "icon-arrow--down",
      "width": "100%",
      "height": "100%"
    }
  })], 1), _vm._v("\n                    Download whitepaper\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "c-home-slide--0__footer__separator u-absolute u-pos-center u-bg--white u-opacity--50"
  }), _vm._v(" "), _c('div', {
    staticClass: "c-home-slide--0__footer__discover u-absolute u-pos-tr u-fit-h u-cursor-pointer",
    on: {
      "click": function($event) {
        _vm.onNextSlide()
      }
    }
  }, [_c('div', {
    staticClass: "c-home-slide--0__footer__discover__text u-absolute u-uppercase t-ffamily--simplon t-fsize--xs t-fweight--bold u-color--white u-align-center"
  }, [(!_vm.$root.isTouch) ? _c('div', {
    staticClass: "u-flex u-flex-ai--center u-flex-jc--space-around"
  }, [_vm._m(1), _vm._v(" "), _c('span', {
    staticClass: "c-home-slide--0__footer__discover__text--1 u-marg-l-xs"
  }, [_vm._v("Scroll")]), _vm._v(" "), _c('span', {
    staticClass: "c-home-slide--0__footer__discover__text--2 u-marg-l-xs"
  }, [_vm._v("to")]), _vm._v(" "), _c('span', {
    staticClass: "c-home-slide--0__footer__discover__text--3"
  }, [_vm._v("discover")])]) : _c('div', [_vm._v("Click or swipe left to discover")])]), _vm._v(" "), _c('div', {
    staticClass: "c-home-slide--0__footer__discover__line u-absolute u-bg--white"
  })]), _vm._v(" "), _c('div', {
    staticClass: "c-home-slide--0__footer__discover-after u-relative u-flex u-flex-ai--center u-flex-jc--center u-w1of6 u-fit-h"
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-home-slide--0__right u-absolute"
  }, [_c('h1', {
    staticClass: "c-home-slide__element has-delay-3 u-hide u-overflow-h u-opacity--0",
    staticStyle: {
      "width": "1px",
      "height": "1px"
    }
  }, [_vm._v("Announcing the Practical TGE")]), _vm._v(" "), _c('div', {
    staticClass: "c-home-slide--0__container__top-right-content c-home-slide__element has-delay-3 u-relative u-zindex--1"
  }, [_c('h2', {
    staticClass: "c-home-slide--0__container__top-right-content__title t-ffamily--neue t-fweight--light u-color--white"
  }, [_c('div', {
    staticClass: "c-home-slide--0__container__top-right-content__title__line--1 u-relative"
  }, [_vm._v("We're on a mission")]), _vm._v(" "), _c('div', {
    staticClass: "c-home-slide--0__container__top-right-content__title__line--2 u-relative"
  }, [_vm._v("to map the world in 3D")]), _vm._v(" "), _c('div', {
    staticClass: "c-home-slide--0__container__top-right-content__title__line--3 u-relative"
  }, [_vm._v("and everything in between.")])])]), _vm._v(" "), _c('div', {
    staticClass: "c-home-slide--0__container__bottom-right-content c-home-slide__element has-delay-4 u-relative u-zindex--1"
  }, [_c('div', {
    staticClass: "c-home-slide--0__container__bottom-right-content__title t-ffamily--neue t-fweight--light u-color--gray-mid"
  }, [_vm._v("\n                        To enable a world where digital and physical become one, we need to help computers understand every "), _c('span', {
    staticClass: "u-color--white"
  }, [_vm._v("MAP")]), _vm._v(", "), _c('span', {
    staticClass: "u-color--white"
  }, [_vm._v("OBJECT")]), _vm._v(", and "), _c('span', {
    staticClass: "u-color--white"
  }, [_vm._v("ACTION")]), _vm._v(".\n                    ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-home-slide--0__footer__discover__icon-container u-relative"
  }, [_c('div', {
    staticClass: "c-home-slide--0__footer__discover__icon-container__border u-relative u-flex u-flex-ai--center u-fit"
  }, [_c('div', {
    staticClass: "c-home-slide--0__footer__discover__icon-container__dot u-bg--white"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53ab38b7"}!./src/scripts/components/app-home-slide-0/template.html
// module id = 467
// module chunks = 0